var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DeviceService } from './device.service';
var BrowserDeviceService = /** @class */ (function (_super) {
    __extends(BrowserDeviceService, _super);
    function BrowserDeviceService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserDeviceService.prototype.isMobileDevice = function () {
        return (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent));
    };
    BrowserDeviceService.prototype.isSafariBrowser = function () {
        return navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.indexOf('Chrome') < 0;
    };
    return BrowserDeviceService;
}(DeviceService));
export { BrowserDeviceService };
